var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7BA1\u7F51\u8282\u70B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0206098%",
    y1: "-32.9793902%",
    x2: "17.0206098%",
    y2: "119.959176%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7E9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-218.000000, -516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7BA1\\u7F51\\u8282\\u70B9",
    transform: "translate(218.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32.561052,
    height: 32.561052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9459086,28.3049468 L8.70844621,28.3049468 C8.06183328,28.3049468 7.51221039,27.8356048 7.51221039,27.2195784 C7.51221039,26.6328751 8.02951589,26.13421 8.70844621,26.13421 L13.9135534,26.13421 C14.5601663,26.13421 15.1097892,26.603552 15.1097892,27.2195784 C15.1097892,27.8356048 14.5924837,28.3049468 13.9459086,28.3049468 Z M21.8330317,4.426842 C17.1599413,4.426842 13.3611519,8.60429148 13.3611519,13.7432304 L13.3611519,15.732492 C13.3611519,16.7934057 12.5772629,17.6222906 11.6426519,17.6222906 C10.6778682,17.6222906 9.92415195,16.7602643 9.92415195,15.732492 L9.92415195,4.55944649 L3.1707368,4.55944649 L3.1707368,15.732492 C3.1707368,20.8713921 6.96952619,25.0488416 11.6426519,25.0488416 C16.3157423,25.0488416 20.1145317,20.8713921 20.1145317,15.732492 L20.1145317,13.7432304 C20.1145317,12.6822779 20.8984206,11.8534318 21.8330317,11.8534318 C22.7978153,11.8534318 23.5515316,12.7154193 23.5515316,13.7432304 L23.5515316,18.9484521 L30.3049468,18.9484521 L30.3049468,13.7432304 C30.3049468,8.63743289 26.5061574,4.426842 21.8330317,4.426842 L21.8330317,4.426842 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe);
export default __webpack_public_path__ + "static/media/pipe.86a692a60fe34f8134e4bd2313ad3a4d.svg";
export { ForwardRef as ReactComponent };